module.exports = __webpack_public_path__ + "img/f6.c4c63406.jpg";